<template>
  <v-card
    v-if="!loading.workspace && workspace"
    flat
    class="shadcn-card"
    max-width="800"
  >
    <div class="shadcn-card-header d-flex align-center justify-space-between">
      <span>Users</span>
      <InviteDialog ref="invite" />
    </div>

    <v-divider class="shadcn-divider"></v-divider>

    <v-data-table
      :loading="loading.workspace"
      class="shadcn-table"
      :headers="headers"
      :items="members"
      mobile-breakpoint="100"
      :hide-default-footer="workspace.members.length < 11"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip v-if="item.invited" bottom max-width="300">
          <template v-slot:activator="{ props }">
            <v-btn
              @click="resendInvite(item.email)"
              v-bind="props"
              class="mr-2"
              icon
              size="small"
              variant="text"
            >
              <v-icon size="16">mdi-email-sync</v-icon>
            </v-btn>
          </template>
          <span>Resend invite</span>
        </v-tooltip>

        <v-tooltip :text="item.invited ? 'Withdraw invite' : 'Remove user'">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              variant="text"
              size="small"
              icon
              :disabled="
                userProfile.role != 'admin' ||
                userProfile.uid === item.uid ||
                (item.role === 'admin' && !item.invited)
              "
              @click="remove(item)"
            >
              <v-icon size="16">mdi-delete-outline</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
      </template>

      <template v-slot:[`item.email`]="{ item }">
        <span
          :style="{ opacity: item.invited ? 0.7 : 1 }"
          style="font-size: 10pt"
        >
          {{ item.email }}
        </span>
        <v-chip
          variant="flat"
          size="x-small"
          color="info"
          class="ml-3"
          v-if="item.invited"
        >
          Invite pending
        </v-chip>
      </template>

      <template v-slot:[`item.role`]="{ item }">
        <v-select
          v-if="
            userProfile?.role &&
            members.find((m) => m.uid === userProfile?.uid).role === 'admin' &&
            item.uid != userProfile?.uid
          "
          variant="outlined"
          density="compact"
          class="shadcn-input"
          style="max-width: 140px"
          placeholder="Role"
          v-model="item.role"
          hide-details
          :items="roles"
          @change="setRole(item)"
        ></v-select>
        <span v-else style="font-size: 10pt">{{ capitalize(item.role) }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import InviteDialog from "@/components/InviteDialog.vue";
import { collection, addDoc } from "firebase/firestore";
import { db } from "@/firebase";

export default {
  components: {
    InviteDialog,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      workspace: (state) => state.workspace.workspace,
      loading: (state) => state.loading,
    }),
    members() {
      let list = this.workspace.invites;

      list.forEach((e) => (e.invited = true));
      return this.workspace.members.concat(list);
    },
  },
  mounted() {
    if (this.$route.query.invite) {
      let child = this.$refs.invite;
      child.open();
    }
  },
  data() {
    return {
      edit: false,
      roles: ["admin", "editor"],
      headers: [
        {
          title: "Email",
          align: "start",
          sortable: false,
          value: "email",
        },
        {
          title: "Role",
          align: "start",
          sortable: false,
          value: "role",
        },
        {
          title: "Actions",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  methods: {
    capitalize(string) {
      console.log(string);
      let firstCharacter = string.charAt(0);
      firstCharacter = firstCharacter.toUpperCase();
      let capitalizedString = firstCharacter + string.slice(1);
      return capitalizedString;
    },
    remove(i) {
      console.log(i);

      if (i.invited) {
        console.log("removing invite");
        this.$store.dispatch("removeInvite", i);
      } else {
        console.log("removing user");
        this.$store.dispatch("removeUser", i);
      }
    },
    async resendInvite(email) {
      await addDoc(collection(db, "mail"), {
        to: [email],
        from: "Stix <info@stix.social>",
        template: {
          name: "colleague-invite",
          data: {
            first_name: this.userProfile.first_name,
            url: `https://app.stix.social/access?ws=${this.userProfile.workspace}&name=${this.workspace.brand.name}`,
          },
        },
      });
      this.$store.commit("setNotification", {
        show: true,
        text: "Invite sent!",
        type: "primary",
        icon: "",
      });
    },
    setRole(v) {
      this.$store.dispatch("updateRole", v);
    },
  },
};
</script>

<style lang="scss" scoped></style>
